/* ============================================================
   ChipFixx — Global Search Router
   File: assets/cf-search-router.js
   Loaded once globally via theme.liquid.

   WHAT IT DOES
   ────────────
   Intercepts the homepage / header search form and the
   "Search for X" links in Dawn's predictive search panel.

   • "Ford L1"          → /pages/ford-paint-codes?code=L1
   • "Ford"             → /pages/ford-paint-codes
   • "L1" / "NH883P"    → /pages/paint-codes?code=L1   (hub w/ banner)
   • "blue", "fender"   → falls through to Shopify default /search

   It NEVER changes Dawn's search files — just listens at the
   document level. If anything breaks, the original Shopify
   search behaviour is what runs.
   ============================================================ */

(function () {
  'use strict';

  /* ── 65 supported makes (with slugs + common aliases) ──── */
  var MAKES = [
    { name: 'Acura',        slug: 'acura',         aliases: [] },
    { name: 'Alfa Romeo',   slug: 'alfa-romeo',    aliases: ['alfa-romeo', 'alfa'] },
    { name: 'AMC',          slug: 'amc',           aliases: [] },
    { name: 'Aston Martin', slug: 'aston-martin',  aliases: ['aston-martin', 'aston'] },
    { name: 'Audi',         slug: 'audi',          aliases: [] },
    { name: 'Austin',       slug: 'austin',        aliases: [] },
    { name: 'BMW',          slug: 'bmw',           aliases: [] },
    { name: 'Bentley',      slug: 'bentley',       aliases: [] },
    { name: 'Buick',        slug: 'buick',         aliases: [] },
    { name: 'Cadillac',     slug: 'cadillac',      aliases: ['caddy'] },
    { name: 'Chevrolet',    slug: 'chevrolet',     aliases: ['chevy'] },
    { name: 'Chrysler',     slug: 'chrysler',      aliases: [] },
    { name: 'Datsun',       slug: 'datsun',        aliases: [] },
    { name: 'Dodge',        slug: 'dodge',         aliases: [] },
    { name: 'Eagle',        slug: 'eagle',         aliases: [] },
    { name: 'Ferrari',      slug: 'ferrari',       aliases: [] },
    { name: 'Fiat',         slug: 'fiat',          aliases: [] },
    { name: 'Ford',         slug: 'ford',          aliases: [] },
    { name: 'Genesis',      slug: 'genesis',       aliases: [] },
    { name: 'GMC',          slug: 'gmc',           aliases: [] },
    { name: 'GM',           slug: 'gm',            aliases: [] },
    { name: 'Honda',        slug: 'honda',         aliases: [] },
    { name: 'Hummer',       slug: 'hummer',        aliases: [] },
    { name: 'Hyundai',      slug: 'hyundai',       aliases: [] },
    { name: 'Infiniti',     slug: 'infiniti',      aliases: [] },
    { name: 'Isuzu',        slug: 'isuzu',         aliases: [] },
    { name: 'Jaguar',       slug: 'jaguar',        aliases: ['jag'] },
    { name: 'Jeep',         slug: 'jeep',          aliases: [] },
    { name: 'Kia',          slug: 'kia',           aliases: [] },
    { name: 'Lamborghini',  slug: 'lamborghini',   aliases: ['lambo'] },
    { name: 'Land Rover',   slug: 'land-rover',    aliases: ['land-rover', 'landrover'] },
    { name: 'Lexus',        slug: 'lexus',         aliases: [] },
    { name: 'Lincoln',      slug: 'lincoln',       aliases: [] },
    { name: 'Lotus',        slug: 'lotus',         aliases: [] },
    { name: 'Maserati',     slug: 'maserati',      aliases: [] },
    { name: 'Mazda',        slug: 'mazda',         aliases: [] },
    { name: 'McLaren',      slug: 'mclaren',       aliases: [] },
    { name: 'Mercedes',     slug: 'mercedes',      aliases: ['mercedes-benz', 'mercedes benz', 'benz', 'merc'] },
    { name: 'Mercury',      slug: 'mercury',       aliases: [] },
    { name: 'MG',           slug: 'mg',            aliases: [] },
    { name: 'Mini',         slug: 'mini',          aliases: [] },
    { name: 'Mitsubishi',   slug: 'mitsubishi',    aliases: ['mitsu'] },
    { name: 'Nissan',       slug: 'nissan',        aliases: [] },
    { name: 'Oldsmobile',   slug: 'oldsmobile',    aliases: ['olds'] },
    { name: 'Plymouth',     slug: 'plymouth',      aliases: [] },
    { name: 'Pontiac',      slug: 'pontiac',       aliases: [] },
    { name: 'Porsche',      slug: 'porsche',       aliases: [] },
    { name: 'Ram',          slug: 'ram',           aliases: [] },
    { name: 'Range Rover',  slug: 'range-rover',   aliases: ['range-rover'] },
    { name: 'Reliant',      slug: 'reliant',       aliases: [] },
    { name: 'Renault',      slug: 'renault',       aliases: [] },
    { name: 'Rivian',       slug: 'rivian',        aliases: [] },
    { name: 'Rolls Royce',  slug: 'rolls-royce',   aliases: ['rolls-royce', 'rolls'] },
    { name: 'Rover',        slug: 'rover',         aliases: [] },
    { name: 'Saab',         slug: 'saab',          aliases: [] },
    { name: 'Saturn',       slug: 'saturn',        aliases: [] },
    { name: 'Scion',        slug: 'scion',         aliases: [] },
    { name: 'Smart',        slug: 'smart',         aliases: [] },
    { name: 'Subaru',       slug: 'subaru',        aliases: ['subie'] },
    { name: 'Suzuki',       slug: 'suzuki',        aliases: [] },
    { name: 'Tesla',        slug: 'tesla',         aliases: [] },
    { name: 'Toyota',       slug: 'toyota',        aliases: [] },
    { name: 'Triumph',      slug: 'triumph',       aliases: [] },
    { name: 'Volkswagen',   slug: 'volkswagen',    aliases: ['vw'] },
    { name: 'Volvo',        slug: 'volvo',         aliases: [] }
  ];

  /* Build a length-DESC sorted list of (token → make) for greedy matching */
  var TOKEN_INDEX = (function () {
    var list = [];
    MAKES.forEach(function (m) {
      list.push({ token: m.name, make: m });
      m.aliases.forEach(function (a) { list.push({ token: a, make: m }); });
    });
    list.sort(function (a, b) { return b.token.length - a.token.length; });
    return list;
  })();

  function regexEscape(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /* Detect a make in a free-text query.
     Returns { make: <make obj or null>, remainder: <cleaned string> } */
  function detectMake(query) {
    if (!query) return { make: null, remainder: '' };
    var padded = ' ' + query.trim() + ' ';
    for (var i = 0; i < TOKEN_INDEX.length; i++) {
      var t = TOKEN_INDEX[i].token;
      var pattern = '([\\s\\-])' + regexEscape(t) + '([\\s\\-])';
      var re = new RegExp(pattern, 'i');
      if (re.test(padded)) {
        var stripRe = new RegExp(pattern, 'gi');
        var remainder = padded.replace(stripRe, ' ').replace(/\s+/g, ' ').trim();
        return { make: TOKEN_INDEX[i].make, remainder: remainder };
      }
    }
    return { make: null, remainder: query.trim() };
  }

  /* Heuristic: does this look like a paint code?
     Rules:
       - 1-12 chars, only [A-Za-z0-9-], no spaces
       - contains a digit, OR is ≤3 alphanumeric chars
     Catches: "L1", "NH883P", "475", "UM", "1G3"
     Skips:   "blue", "metallic", "Ford F-150" (has space) */
  function looksLikeCode(s) {
    var t = s.trim();
    if (!t || t.length > 12) return false;
    if (!/^[A-Za-z0-9\-]+$/.test(t)) return false;
    if (/\d/.test(t)) return true;
    if (t.length <= 3) return true;
    return false;
  }

  function getRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  }

  /* Decide where (if anywhere) to redirect.
     Returns a URL string or null (null = fall through to default search) */
  function buildRoute(rawQuery) {
    var raw = (rawQuery || '').trim();
    if (!raw) return null;

    var parsed = detectMake(raw);

    /* Case A: make matched */
    if (parsed.make) {
      var url = getRoot() + 'pages/' + parsed.make.slug + '-paint-codes';
      if (parsed.remainder) {
        url += '?code=' + encodeURIComponent(parsed.remainder);
      }
      return url;
    }

    /* Case B: looks like a paint code on its own → hub with banner */
    if (looksLikeCode(raw)) {
      return getRoot() + 'pages/paint-codes?code=' + encodeURIComponent(raw);
    }

    /* Case C: not a paint query → null = let Shopify handle it */
    return null;
  }

  /* ── Intercept search FORM submissions ────────────────── */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var route = buildRoute(input.value);
    if (route) {
      event.preventDefault();
      window.location.href = route;
    }
  }, true);

  /* ── Intercept clicks on predictive-search "Search for X" links ── */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href*="/search"]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    var m = href.match(/[?&]q=([^&]+)/);
    if (!m) return;

    var raw;
    try {
      raw = decodeURIComponent(m[1].replace(/\+/g, ' '));
    } catch (e) {
      return;
    }

    var route = buildRoute(raw);
    if (route) {
      event.preventDefault();
      window.location.href = route;
    }
  }, true);

  /* ── Expose helpers for other ChipFixx scripts to reuse ── */
  window.CFSearch = {
    detectMake: detectMake,
    looksLikeCode: looksLikeCode,
    buildRoute: buildRoute,
    MAKES: MAKES
  };

})();